import React from 'react';
import { SerializedStyles, css } from '@emotion/react';
import { useTheme } from '@veneer/theme';

const useStyles = (): {
  root: {
    base: SerializedStyles;
    compact: SerializedStyles;
    notCompact: SerializedStyles;
    sub: SerializedStyles;
  };
  bullet: SerializedStyles;
  icon: {
    base: SerializedStyles;
    check: SerializedStyles;
    minus: SerializedStyles;
  };
  item: SerializedStyles;
  text: SerializedStyles;
} => {
  const theme = useTheme();
  return React.useMemo(() => {
    return {
      root: {
        base: css({
          display: 'flex',
          flexDirection: 'column',
        }),

        compact: css({
          padding: theme.layout.size2,
        }),
        notCompact: css({
          marginTop: theme.layout.size1,
        }),

        sub: css({
          display: 'flex',
          flexDirection: 'column',
          marginLeft: theme.layout.size8,
        }),
      },
      bullet: css({
        backgroundColor: theme.color.foreground.disabled,
        borderRadius: theme.borderRadius2,
        height: theme.layout.size2,
        margin: theme.passwordRequirements.bulletMargin,
        maxWidth: theme.layout.size2,
        width: '100%',
      }),
      icon: {
        base: css({
          height: '100%',
          marginRight: theme.layout.size1,
          maxHeight: theme.passwordRequirements.iconWidthHeight,
          maxWidth: theme.passwordRequirements.iconWidthHeight,
          padding: 0,
          paddingTop: theme.passwordRequirements.iconPadding,
          width: '100%',
        }),
        check: css({
          fill: theme.color.positive.base.default,
        }),
        minus: css({
          fill: theme.color.negative.base.default,
        }),
      },
      item: css({
        alignItems: 'flex-start',
        display: 'flex',
        marginTop: theme.passwordRequirements.itemMargin,
        marginBottom: theme.passwordRequirements.itemMargin,
      }),
      text: css({
        ...theme.typography.captionRegular,
        alignSelf: 'center',
        color: theme.color.foreground.default,
        wordBreak: 'break-word',
      }),
    };
  }, [theme]);
};

export default useStyles;
